import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Amplify from 'aws-amplify';
import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { withAuthenticator } from './aws-amplify-react/Auth/index';
import PageHeader from './pages/PageHeader';
import Routes from './Routes';
import * as CONFIG from './api/config';
// import { version } from '../package.json';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Auth } from 'aws-amplify';
import * as Icon from 'react-feather';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import Container from './pages/container';
import { ApolloClient } from 'apollo-client';
import { onError } from 'apollo-link-error';
import { ApolloLink, Observable } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from '@apollo/react-hooks';
import NotificationContainer from 'react-notifications/lib/NotificationContainer';


require('./bmd.css');
require('./footer.css');
Amplify.configure(CONFIG.aws_cognito);
const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      light: '#0066ff',
      main: '#318fa9',
      // contrastText: '#ffcc00',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contast with palette.primary.main
    },
    secondary: {
      light: '#387025',
      main: '#387025',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#CDEEF5',
    },
    typography: {
      fontFamily: 'Josefin Sans',
    }
  },
});

const styles = {
  root: {
    flexGrow: 1,
    background: "#318fa9",

  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  button: {
    color: '#B2EBF2',
    background: "#318fa9",
  },
  select: {
    backgroundColor: '#318fa9'
  },
  normal: {
    backgroundColor: '#fff'
  },
  select1: {
    color: '#fff'
  },
  normal1: {
    color: '#318fa9'
  }


  //# 0 d7782
};

const cache = new InMemoryCache({
  cacheRedirects: {
    Query: {
      movie: (_, { id }, { getCacheKey }) =>
        getCacheKey({ __typename: 'Movie', id })
    }
  }
});


const request = async (operation) => {
  let userInfo = await Auth.currentAuthenticatedUser();
  // console.log('jwtToken=>', jwtToken);
  let username = localStorage.getItem('username');
  if (!username || username === 'undefined')
    username = '';
  console.log('username=>', username);
  operation.setContext({
    headers: {
      authorization: userInfo.signInUserSession.idToken.jwtToken,
      'X-Api-Key': username
    },
  });
};

const requestLink = new ApolloLink((operation, forward) =>
  new Observable(observer => {
    let handle;
    Promise.resolve(operation)
      .then(oper => request(oper))
      .then(() => {
        handle = forward(operation).subscribe({
          next: observer.next.bind(observer),
          error: observer.error.bind(observer),
          complete: observer.complete.bind(observer),
        });
      })
      .catch(observer.error.bind(observer));

    return () => {
      if (handle) handle.unsubscribe();
    };
  })
);


const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        console.error(graphQLErrors);
        // sendToLoggingService(graphQLErrors);
      }
      if (networkError) {
        console.error(networkError);
        // logoutUser();
      }
    }),
    requestLink,
    new HttpLink({
      uri: `${CONFIG.ApiUrl}/public/graphql`,
      // credentials: 'include'
    })
  ]),
  cache,
  resolvers: {
    Mutation: {
      updateNetworkStatus: (_, { isConnected }, { cache }) => {
        cache.writeData({ data: { isConnected } });
        return null;
      }
    }
  },
});

class App extends Component {
  state = {
    auth: true,
    anchorEl: null,
    loginMenuItem: 'Logout',
    open: true,
    selectedindex: 0,
  };

  handleChange = (event, checked) => {
    this.setState({ auth: checked });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };
  handleLogout = async () => {
    try {
      localStorage.removeItem('profession');
      localStorage.removeItem('wpopup');
      await Auth.signOut();
    }
    catch (ex) { }
    // this.props.history.push("/signout");
    //   Auth.signOut().then(() => {
    //   console.log('signedOut');
    // }).catch(err => {
    //   console.log(err);
    //   this.error(err);
    // });
    this.setState({ anchorEl: null, loginMenuItem: 'Login', });
  }
  handleListItemClick = (event, index) => {
    this.setState({ selectedIndex: index });
  };
  componentDidMount() {
    const ele = document.getElementById('ipl-progress-indicator')
    if (ele) {
      // fade out
      ele.classList.add('available')
      setTimeout(() => {
        // remove from DOM
        ele.innerHTML = ''
      }, 2000)
    }
  }

  render() {
    return (
      <ApolloProvider client={apolloClient}>
        <NotificationContainer />
        <Router>
          <MuiThemeProvider theme={theme}>

            <div className="flyout" style={{ overflowX: 'hidden' }}>
              {<PageHeader />}
              {<Container />}

              {/* <footer className="pt-4  footer-top-border">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-md">
                    <small className="d-block mb-3 text-muted">&copy; 2018-2019 NHRA, Version {version} Hosting [{process.env.REACT_APP_HOST_ENV}]-Runtime [{process.env.NODE_ENV}]</small>
                  </div>
                </div>
              </div>
            </footer> */}


            </div>
          </MuiThemeProvider>
        </Router>
      </ApolloProvider>
    );
  }
}

export default withAuthenticator(App);
